/**
 * @generated SignedSource<<9a864680a3236c24cffadacb43392f06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DashboardBlockPosition = "main" | "side" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ContinueYourProductsDashboardBlockFragment$data = {
  readonly id: string;
  readonly position: DashboardBlockPosition;
  readonly products: {
    readonly totalCount: number;
  };
  readonly " $fragmentSpreads": FragmentRefs<"DashboardBlockAdminDropdownFragment" | "DashboardBlockItemTemplateFragment">;
  readonly " $fragmentType": "ContinueYourProductsDashboardBlockFragment";
};
export type ContinueYourProductsDashboardBlockFragment$key = {
  readonly " $data"?: ContinueYourProductsDashboardBlockFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContinueYourProductsDashboardBlockFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContinueYourProductsDashboardBlockFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "position",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductNodeConnection",
      "kind": "LinkedField",
      "name": "products",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardBlockItemTemplateFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardBlockAdminDropdownFragment"
    }
  ],
  "type": "ContinueYourProductsDashboardBlock",
  "abstractKey": null
};

(node as any).hash = "9bd8e2c1d3e85a1697f9762be2ac176a";

export default node;
